module.exports = __webpack_public_path__ + "static/media/view4.86d8a680.jpg";